import Component from '@cell/cell-core/component/component';
import './snowflakes.scss';

class Snowflakes extends Component {
  constructor() {
    super();

    this.handleToggleSnowflakes = this.handleToggleSnowflakes.bind(this);
    this.handleUserPreferencesEvent = this.handleUserPreferencesEvent.bind(this);
  }

  componentDidMount() {
    globalThis.on('c-toggle.input.toggle-snowflakes', this.handleToggleSnowflakes);

    document.addEventListener(
      'user-preferences.snowflakes-disabled',
      this.handleUserPreferencesEvent,
    );
  }

  handleToggleSnowflakes(event) {
    // Checked in this case means the snowflakes are disabled.

    const { checked } = event.data;

    if (checked) {
      this.disable();
    } else {
      this.enable();
    }
  }

  handleUserPreferencesEvent(event) {
    const { snowflakesDisabled } = event.detail.data;

    if (snowflakesDisabled) {
      this.disable();
    } else {
      this.enable();
    }
  }

  enable() {
    this.classList.add('snowflakes--enabled');
  }

  disable() {
    this.classList.remove('snowflakes--enabled');
  }
}

customElements.define('c-snowflakes', Snowflakes);
